import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const AskRedoSlackOutcomeSchema = z.enum([
  "answer",
  "clarify",
  "escalate_support",
  "loop_in_am",
  "no_reply",
  "error",
]);

const askRedoSlackTeamSchema = z.object({
  teamId: zExt.objectId(),
  teamName: z.string(),
  slackChannelIds: z.array(z.string()),
  enabled: z.boolean(),
});

const askRedoSlackDecisionSchema = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  teamId: zExt.objectId(),
  teamName: z.string().optional(),
  slackChannelId: z.string(),
  slackMessageTs: z.string(),
  slackThreadTs: z.string().optional(),
  slackRootTs: z.string(),
  outcome: AskRedoSlackOutcomeSchema,
  confidence: z.number(),
  reason: z.string(),
  responseText: z.string().optional(),
  triggerSource: z.string().optional(),
  permalink: z.string().optional(),
  askRedoThreadId: z.string().optional(),
  errorMessage: z.string().optional(),
});

export const getAskRedoSlackDashboard = {
  name: "getAskRedoSlackDashboard" as const,
  input: z.object({
    teamId: zExt.objectId().optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().optional(),
    outcome: AskRedoSlackOutcomeSchema.optional(),
  }),
  output: z.object({
    teams: z.array(askRedoSlackTeamSchema),
    decisions: z.array(askRedoSlackDecisionSchema),
    totalCount: z.number(),
  }),
};
